import { PetTypeIds } from "@spike/model";
export var getBreed = function (breedId, petTypeId, masterData) {
    return getMasterDataBreeds(petTypeId, masterData).find(function (breed) { return breed.id === breedId; });
};
export var getMasterDataBreeds = function (petTypeId, masterData) {
    if (petTypeId === PetTypeIds.DOGS) {
        return masterData.breeds.dogs;
    }
    else if (petTypeId === PetTypeIds.CATS) {
        return masterData.breeds.cats;
    }
    else if (petTypeId === PetTypeIds.EXOTICS) {
        return masterData.breeds.exotics;
    }
    else {
        return [];
    }
};
